import * as React from 'react';
import { DsiOptionWithDefinition as OptionWithDefinition } from './OptionWithDefinition';
import { __ } from 'react-i18n/lib';
import { Subtitle } from './OrderDetail';

interface Props {
  title: string;
  delivery: string;
  payMethod: string;
  payback: string;
  currency: string;
  credit: string;
  freeCredit: string;
}

function PaymentOptions(props) {
  const {
    title,
    delivery,
    payMethod,
    payback,
    currency,
    credit,
    freeCredit,
  } = props;

  return (
    <>
      <Subtitle marginBottom={32}>{title}</Subtitle>
      {!!delivery && (
        <OptionWithDefinition
          marginBottom={16}
          title={`${__('Doprava')}`}
          value={delivery}
        />
      )}
      {!!payMethod && (
        <OptionWithDefinition
          marginBottom={16}
          title={`${__('Platba')}`}
          value={payMethod}
        />
      )}
      {/* <OptionWithDefinition
        marginBottom={16}
        title={`${__('Splatnosť')}`}
        value={payback}
      />
      <OptionWithDefinition
        marginBottom={16}
        title={`${__('Kredit')}`}
        value={`${credit} ${currency}`}
      />
      <OptionWithDefinition
        title={`${__('Voľný kredit')}`}
        value={`${freeCredit} ${currency}`}
      /> */}
    </>
  );
}

export { PaymentOptions as DsiPaymentOptions };
